// extracted by mini-css-extract-plugin
export default {"formstyle":"ContactForm_formstyle__JhBri","label":"ContactForm_label__-cVXI","input":"ContactForm_input__Bl93P","button":"ContactForm_button__eSwX9"};